module.exports = "<div class=\"ot-modal-action-bar\">\n  <ot-separator params=\"{'type': 'horizontal'}\"></ot-separator>\n\n  <div class=\"ot-full-container\">\n    <div class=\"row\">\n      <!-- the order matters: the first has to be the one with the submit action as angular will call it when enter is pressed -->\n      <button class=\"btn btn-default ot-modal-right-container\" ng-click=\"params.right.callback()\">{{params.right.label | translate}}</button>\n      <button class=\"btn btn-default ot-modal-left-container\" ng-click=\"params.left.callback()\">{{params.left.label | translate}}</button>\n\n    </div>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/modalActionBar.html
 ** module id = 270
 ** module chunks = 1
 **/